import { render, staticRenderFns } from "./TransactionCompleteModal.vue?vue&type=template&id=5dd64418"
import script from "./TransactionCompleteModal.vue?vue&type=script&lang=js"
export * from "./TransactionCompleteModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionCompleteModal.vue?vue&type=style&index=0&id=5dd64418&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports